var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "two-column-rich-text grid grid__base" }, [
    _c("div", { staticClass: "grid--container" }, [
      _c(
        "div",
        { staticClass: "grid--row" },
        _vm._l(_vm.plugins, function(plugin, pluginIdx) {
          return _c(
            "div",
            {
              key: pluginIdx,
              staticClass: "two-column-rich-text--col grid--col"
            },
            [
              _c(
                plugin.type,
                _vm._b(
                  { tag: "component", attrs: { "is-nested": true } },
                  "component",
                  _vm.bindCmsPluginAttrs(plugin),
                  false
                )
              )
            ],
            1
          )
        })
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37687050", { render: render, staticRenderFns: staticRenderFns })
  }
}